import { CreditCard } from "lucide-react";
import { paymentLinksFor, waLink } from "@/config";

const STACK_BTN =
  "inline-flex items-center justify-center gap-2 rounded-full border border-gold/40 px-4 py-3 text-xs sm:text-sm font-semibold text-gold transition-all duration-300 hover:border-gold hover:bg-gold/10";
const INLINE_BTN =
  "inline-flex items-center gap-2 rounded-full bg-gold px-5 py-3 text-xs sm:text-sm font-semibold text-ink transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_28px_rgba(212,175,55,0.35)]";

const PayButtons = ({ productId, title, testId, variant = "stack" }) => {
  const links = paymentLinksFor(productId).filter((l) => l.url && l.url.startsWith("http"));
  const isStack = variant === "stack";

  if (!links.length) {
    return (
      <a
        href={waLink(`Merhaba, ${title} için kart ile ödeme linki almak istiyorum.`)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`${testId}-pay`}
        className={isStack ? `mt-4 w-full ${STACK_BTN}` : INLINE_BTN}
      >
        <CreditCard className="w-4 h-4" />
        {isStack ? "Kart ile Satın Al" : "Kart ile Al"}
      </a>
    );
  }

  return (
    <div
      className={
        isStack
          ? `mt-4 grid gap-3 ${links.length > 1 ? "sm:grid-cols-2" : ""}`
          : "flex flex-wrap gap-3"
      }
    >
      {links.map((l) => (
        <a
          key={l.url}
          href={l.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testId}-pay-${l.label}`}
          className={isStack ? STACK_BTN : INLINE_BTN}
        >
          <CreditCard className="w-4 h-4 shrink-0" />
          {l.label}
        </a>
      ))}
    </div>
  );
};

export default PayButtons;
